module.exports = __webpack_public_path__ + "images/category_lp/fishing_gear/store_images/2_f38f561c3d8972bb60b8499c3d2a46c1.png";